import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { useTranslation } from 'next-i18next'
import { Body2, Headline2 } from 'stories/elements/Typography/Text'
import { returnDownloadButton } from 'lib/features/downloadNativeButtons'
import { useRouter } from 'next/router'
import { parseLocale } from 'lib/constants/localization'

const Container = styled.div`
    width: 100%;
    background-color: ${theme.colors.darkBlackTransparent};
    overflow: hidden;
    padding: 50px 0;
    section {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: left;
        .buttons {
            display: flex;
            gap: 10px;
            width: 250px;
            justify-content: left;
            @media (max-width: 750px) {
                flex-wrap: wrap;
                width: 100%;
            }
        }
        @media (max-width: 750px) {
            width: 80%;
        }
    }
`

const AiUsageDownloadComponent = () => {
    const { t } = useTranslation('aiUsage')
    const { locale } = useRouter()
    const parsedLocale = parseLocale(locale)

    return (
        <Container>
            <section>
                <Headline2 fontSize={36} fontWeight={700} color={theme.colors.white} marginBottom={20}>
                    {t('aiUsage/downloadCardTitle')}
                </Headline2>
                <Body2
                    color={`${theme.colors.white}99`}
                    marginBottom={50}
                    fontFamily="var(--font-inter)"
                    fontWeight={400}
                    fontSize={15}
                >
                    {t('aiUsage/downloadCardText')}
                </Body2>
                <div className="buttons">
                    {returnDownloadButton(parsedLocale, 'ios')}
                    {returnDownloadButton(parsedLocale, 'android')}
                </div>
            </section>
        </Container>
    )
}

export default AiUsageDownloadComponent
